export const LanguageEventTypes = {
  ACTIVE_LANGUAGE_CODE_CHANGED: "ACTIVE_LANGUAGE_CODE_CHANGED",
};
